// Section specific scripts come here

document.addEventListener('DOMContentLoaded', function(event) {
  const style = document.createElement('style')
  style.innerHTML = '.animation { display: block; } svg { display: block !important; } .main { display: block !important }'
  // for now we only inject this in container sections as I m not sure how it will behave on others
  const lottiePlayers = document.querySelectorAll('.container-section lottie-player');
  lottiePlayers.forEach(function (player) {
    player.addEventListener('load', function () {
      player.shadowRoot.appendChild(style);
    });
  });
  playLottieInSection();
});

const playLottieInSection = () => {
  const sections = document.querySelectorAll('section');
  if (sections) {
    sections.forEach((section) => {
      const lottiePlayer = section.querySelector('dotlottie-player');
      if (section.classList.contains('tiles-section') || section.classList.contains('cards-section')) { return }
      let prevRatio = 0.0;
      const playLottie = () => {
        let lottie_flag = 0;
        if (lottiePlayer) {
          createObserver();
        }
        function createObserver () {
          let options = {
            rootMargin: "0px",
            threshold: 0.2
          };

          const observer = new IntersectionObserver(handleIntersect, options);
          observer.observe(section);
        }
        function handleIntersect (entries, observer) {
          entries.forEach((entry) => {
            if (lottie_flag != 1) {
              if (entry.intersectionRatio > prevRatio) {
                try {
                  lottiePlayer.autoplay = true;
                  lottiePlayer.play();
                  lottie_flag = 1;
                } catch(e) {
                  console.log(`${e} - lottiePlayer.play() error`);
                }
              } else {
                lottiePlayer.stop();
              }
            }
            prevRatio = entry.intersectionRatio;
          });
        }
      }
      playLottie();
    });
  }
}




